export const EMAIL_VALIDATION_REGEX =
  /^[A-Za-z0-9!#$%&'*\+\-/=?^_`{|}~]+(?:\.?[A-Za-z0-9!#$%&'*\+\-/=?^_`{|}~])*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
